import Tag from './Tag';

export { Tag };
